// src/utils/FileCache.js

let uploadedFilesCache = [];

export const setUploadedFiles = (files) => {
  uploadedFilesCache = files;
};

export const getUploadedFiles = () => uploadedFilesCache;

export const clearUploadedFiles = () => {
  uploadedFilesCache = [];
};
